import { RunContextApp }                              from "framework/RCApp";
import { ApiResponse }                                from "types";
import { WIDGETS_SDK_API_ERROR_CODES,
         WidgetsSdkEncKeyPairResponse
       }                                              from "types/apis/widgetSdkInterfaces";

export const WidgetsSdkApis = {

  getWidgetsSdkEncKeyPair : async (rc : RunContextApp, clientId : string, accessToken : string) : Promise<ApiResponse<WidgetsSdkEncKeyPairResponse>> => {

    const resp = await rc.apiClient.get<WidgetsSdkEncKeyPairResponse>(`/v2.0/encryption/key/${clientId}`, {
      headers : {
        Authorization : `Bearer ${accessToken}`
      }
    })

    if (resp.error) {

      if (resp.error.code === WIDGETS_SDK_API_ERROR_CODES.ERROR_ENCRYPTION_KEY_NOT_FOUND) {
        
        const keyPairResp = await rc.apiClient.post<WidgetsSdkEncKeyPairResponse>(`/v2.0/encryption/key`, {
          clientId : clientId
        }, {
          headers : {
            Authorization : `Bearer ${accessToken}`
          }
        })

        if (keyPairResp.error) {
          return { error : keyPairResp.error }
        }

        const data = keyPairResp.data
        return { data }
      }

      return {
        error : resp.error
      }
    } else {
      const data = resp.data
      return { data }
    }
  }
  
}